export default function Footer() {
  return (
    <footer className="bg-[#000000] text-white py-12 px-4">
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-2 gap-8 mb-8">
          {/* Left Column */}
          <div>
            <h3 className="text-2xl font-bold mb-4">Andrea Disanto - Consulente Ads</h3>
            <p className="text-gray-300 leading-relaxed">
              Oltre 10 anni di esperienza nella gestione di Campagne Google Ads e Meta.<br />
              Ex-Google, esperienza multinazionale. Oggi al servizio delle PMI italiane
            </p>
          </div>

          {/* Right Column */}
          <div>
            <h4 className="text-xl font-semibold mb-4">Contatti</h4>
            <div className="space-y-2 text-gray-300">
              <p>andrea@consulentecertificatoads.it</p>
              <p>+39 3927112051</p>
              <p>Bari, Italia</p>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-800 pt-6">
          <p className="text-sm text-gray-400 text-center">
            © 2025 Andrea Disanto Consulente Ads. Tutti i diritti riservati.
          </p>
        </div>
      </div>
    </footer>
  );
}